export interface SlackSettings {
  "slack-app-token": string | null;
  "slack-bug-report-channel": string | null;
}
